module.exports = __webpack_public_path__ + "img/logo-youtube.9c68387f.svg";